// extracted by mini-css-extract-plugin
module.exports = {"list":"Location_list__4pNAQ","item":"Location_item__1ubSN","active":"Location_active__1J74G"};